var Viewport;
(function (Viewport) {
    Viewport["SmallWidth"] = "SMALL_WIDTH";
    Viewport["MediumWidth"] = "MEDIUM_WIDTH";
    Viewport["LargeWidth"] = "LARGE_WIDTH";
})(Viewport || (Viewport = {}));
export default Viewport;
